import { useGetApiV1ClassroomdisciplineSharedClassStudents } from '@/shared/api/generated';

import { mapDropdownOptions, useDebouncedFilter } from './useLookupSearch';

/**
 * Busca de turmas (class-students) por texto (debounce + mínimo de 3 caracteres)
 * para o autocomplete de "Vincular turma". Consome o lookup `shared/class-students`.
 *
 * @param filter - Texto digitado no campo (default `''`).
 * @returns `{ options, isLoading, isQuerySuccess }`.
 */
export function useClassStudentSearchDropdown(filter = '') {
  const { debouncedFilter, isReady } = useDebouncedFilter(filter);

  const { data, isLoading, isSuccess } = useGetApiV1ClassroomdisciplineSharedClassStudents(
    isReady ? { Search: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );

  return { options: mapDropdownOptions(data), isLoading, isQuerySuccess: isSuccess } as const;
}
